const _ = require('underscore');
const { appendDynamicInfoToSchema, result } = require('./src/index');

const schemaVnextArray = _.map(result);
const schemaVnextObj = result;

// here we use CommonJS style export to dynamically export all values in result
// eslint-disable-next-line
module.exports = _.defaults({
  appendDynamicInfoToSchema,
  schemaVnextArray,
  schemaVnextObj,
}, result);
